/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomerTypeResponse } from '../models/customer-type-response';
import { getCustomerTypes } from '../fn/customer-types/get-customer-types';
import { GetCustomerTypes$Params } from '../fn/customer-types/get-customer-types';

@Injectable({ providedIn: 'root' })
export class CustomerTypesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomerTypes()` */
  static readonly GetCustomerTypesPath = '/customer-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerTypes$Response(params?: GetCustomerTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerTypeResponse>>> {
    return getCustomerTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerTypes(params?: GetCustomerTypes$Params, context?: HttpContext): Observable<Array<CustomerTypeResponse>> {
    return this.getCustomerTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerTypeResponse>>): Array<CustomerTypeResponse> => r.body)
    );
  }

}
